import { formatTitleDate } from '@lingoda/booking';
import { FormattedMessage, trans } from '@lingoda/i18n';
import { Stack, Typography } from '@lingoda/ui';
import type { LeadTime } from './resolveLeadTime';

type Props = LeadTime & {
    htmlColor: string;
    layout?: 'inline' | 'stacked';
};

export const LeadTimeExplanationMessage = ({
    leadTimeInDays,
    firstDateBeyondLeadTime,
    htmlColor,
    layout = 'inline',
}: Props) => {
    const explanation = (
        <FormattedMessage
            message={trans(
                'lead-time-explanation',
                { days: leadTimeInDays, date: formatTitleDate(firstDateBeyondLeadTime) },
                'student-booking',
            )}
            values={{ b: (chunks) => <b>{chunks}</b> }}
        />
    );
    const continuation = trans('lead-time-explanation-continued', {}, 'student-booking');

    if (layout === 'stacked') {
        return (
            <Stack spacing={1}>
                <Typography variant="body2" htmlColor={htmlColor}>
                    {explanation}
                </Typography>
                <Typography variant="body2" htmlColor={htmlColor}>
                    {continuation}
                </Typography>
            </Stack>
        );
    }

    return (
        <Typography variant="body2" htmlColor={htmlColor}>
            {explanation} {continuation}
        </Typography>
    );
};
